module.exports = __webpack_public_path__ + "https://gloprocessor.com/ment/img/Slice 17@2x.77b4c440.png";